import { getRuntimeConfig } from './collectionAPI';
export class DataSourceBase {
    collectionId;
    projectId;
    constructor(options) {
        this.collectionId = options.collectionId;
        this.projectId = options.projectId;
    }
    async getCollectionInfo() {
        return await getRuntimeConfig({
            collectionId: this.collectionId,
            projectId: this.projectId,
        });
    }
}
